var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 152.32 200.88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n        stroke: #ee3731;\n        stroke-miterlimit: 10;\n        stroke-width: 2.37px;\n      }\n\n      .cls-2 {\n        fill: #fb9402;\n      }\n\n      .cls-2, .cls-3, .cls-4 {\n        fill-rule: evenodd;\n      }\n\n      .cls-3 {\n        fill: #fbe102;\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -1420.51,
    y1: -706.01,
    x2: -1420.51,
    y2: -682.38,
    gradientTransform: "translate(4483.89 -2109.54) scale(3.14 -3.14)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff4c0d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fb9402"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "fire"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-1",
    className: "cls-4",
    d: "M54.66,79.22c-.61,14.56-12.6,26.18-27.32,26.18S0,92.75,0,78.06C0,76.1-.04,72.17,2.91,65.55c1.76-3.96,2.87-6.45,3.49-8.73.34-1.25,1.01-3.24,2.91,0,1.12,1.91,1.16,4.65,1.16,4.65,0,0,4.17-3.2,6.98-9.31,4.12-8.96.83-14.31-.29-18.04-.39-1.29-.63-3.6,2.04-2.62,2.72,1,9.91,6.04,13.67,11.35,5.37,7.57,7.27,14.84,7.27,14.84,0,0,1.72-2.13,2.33-4.36.69-2.52.7-5.01,2.91-2.33,2.1,2.56,5.22,7.36,6.98,11.93,3.19,8.29,2.3,16.29,2.3,16.29h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-2",
    className: "cls-2",
    d: "M27.35,105.41c-10.44,0-18.91-8.47-18.91-18.91,0-6.3,2.54-10.13,7.82-15.32,3.38-3.32,6.55-7.4,7.9-10.18.27-.55.87-3.4,3.19-.06,1.22,1.75,3.13,4.86,4.36,7.52,2.11,4.58,2.62,9.02,2.62,9.02,0,0,2.07-1.22,3.49-4.36.46-1.01,1.38-4.85,3.97-1.01,1.9,2.81,4.5,7.87,4.47,14.4,0,10.44-8.47,18.91-18.91,18.91h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-3",
    className: "cls-3",
    d: "M27.64,84.75c2.69,0,2.69,4.98,6.11,11.64,2.28,4.43-1.13,9.02-6.11,9.02s-7.56-4.04-7.56-9.02,4.87-11.64,7.56-11.64Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M137.7,144.13V15.88c0-8.12-6.58-14.7-14.7-14.7h0c-8.12,0-14.7,6.58-14.7,14.7v128.25c0,1.98-.87,3.89-2.44,5.1-7.09,5.45-11.52,14.21-10.96,23.97.8,14.07,12.23,25.57,26.3,26.44,16.36,1.02,29.94-11.95,29.94-28.09,0-9.09-4.31-17.16-10.99-22.31-1.58-1.21-2.46-3.12-2.46-5.11Z"
  }), /*#__PURE__*/React.createElement("image", {
    width: 40,
    height: 183,
    transform: "translate(103.14 8.59)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAC3CAYAAABgzhz7AAAACXBIWXMAAAsSAAALEgHS3X78AAACbElEQVR4nO2cS1LCQBiE/z8FK/VmPpe+8AJ6Gr2A+NhR4uNmxBVVjgsqCYEEkmkIrdVfFRuSOB/dmdRkFrqBTB+SsOp4//bHkb8PXbxOLgORjL5wet9MLqN/FyeZxFzUVg4hSjCG2B/Vixqts/w6TDCWuASxyd8KVYxCL0hfcZRgd1NEFePQJ0gvqIpRIhPs7kFDnyC9oCYJigRRdA+i0AuqYhR6QS0WUDRJUOgF417cVXEBvaBmMQq9oCpG0S4/Cn3F9IKqGEUJotALqmIUekFVjKKtDxR6QU0SFHpBVYxCL6jtNxR6Qc1iFPoE6TePVDEKfYL0gqoYRQmi0AuqYhQliEIvSF8x/XqQPkH6e5BeUBWj0AuqYhQliEIvqIpR6AXpK9Z6EIX+HqQXVMUoShCF/r8EqGIUJYhCL6iKUZQgCn2C9Et+VYyiBFGUIAp9gvSCqhhFCaLQC6pilNYLu3CzB+Xnj9+txvxfCaLp5YO2SLHRiWGwGbHSwMNmkmtPCoP9rc5ZH6YrHWoPhuvtipUknuolKw90KZeL1EgufRmuupfL8OdlSarHTFU4JeNwubv05vGXIsk8QRa5RYqKA88nXBRhuVn5Cyb8NfXZcotSb0YSzjnTy3B2wR5zvWZkD+oqlCCKEkShF1TFKPQJ0gtSV+yj1BMfpW7BjfJj5Amazb00hbMDqrvR3yZu9pcSNONJMUvPbHELmEDPx5NSaMtbH6e7S3FRzqziHvTxxHf2TlwlXfdrwkl3Sfr7cnL5sXUXh+PtivpHvZxZ0y3go+1I+udqObO2m+gbEm0ilp8bM0A4bC/qX82l/hS/3B8LIdFCaHwAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-2-2",
    "data-name": "path-2",
    className: "cls-2",
    d: "M123,191.41c-7.43,0-13.46-6.03-13.46-13.46,0-4.48,1.81-7.21,5.57-10.9,2.41-2.36,4.66-5.27,5.62-7.25.19-.39.62-2.42,2.27-.04.87,1.25,2.23,3.46,3.1,5.35,1.5,3.26,1.86,6.42,1.86,6.42,0,0,1.47-.87,2.48-3.11.33-.72.98-3.45,2.82-.72,1.35,2,3.21,5.6,3.18,10.25,0,7.43-6.03,13.46-13.46,13.46h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-3-2",
    "data-name": "path-3",
    className: "cls-3",
    d: "M123.29,175.02c2.14,0,2.14,3.95,4.85,9.23,1.81,3.52-.9,7.16-4.85,7.16s-6-3.2-6-7.16,3.87-9.23,6-9.23Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHot);
export default __webpack_public_path__ + "static/media/hot.319ef2fb890e37b8b8df11703974a4c3.svg";
export { ForwardRef as ReactComponent };